import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import FileSaver from 'file-saver';
import { DrugDataStore } from '../../providers/data/drug-data-store';

@IonicPage()
@Component({
  selector: 'page-transfer-data',
  templateUrl: 'transfer-data.html',
})
export class TransferDataPage {

  public static isEditMode = location.href.split('?').indexOf("edit=1") >= 0;
  @ViewChild('fileInput') public fileInputRef: ElementRef;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingCtrl: LoadingController,
    private dds: DrugDataStore,
    private data: DataProvider
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TransferDataPage');
  }

  uploadFile() {
    const file = this.fileInputRef.nativeElement.files[0];
    if (!file) {
      alert("Keine Datei ausgewählt");
      return;
    }


    let loading = this.loadingCtrl.create({
      content: 'Bitte warten...'
    });
    loading.present();
    this.data.loadAndInitializeData(window.URL.createObjectURL(file)).subscribe(() => {
      loading.dismiss();
    });
  }

  downloadFile() {
    var jsonString = JSON.stringify(this.dds);
    var blob = new Blob([jsonString], { type: "application/json;charset=utf-8" });
    FileSaver.saveAs(blob, "arzneiundhaut-data.json");
  }

}



// WEBPACK FOOTER //
// ./src/pages/transfer-data/transfer-data.ts